import React from "react";
import { connect } from "react-redux";

const JournalCategory = ({ setIsRecipe, setIsFoodItem }) => {
	return (
		<div>
			<p>
				Keeping an accurate food journal can be the difference between a lifetime of wellness and a lifetime of weight
				struggles.
			</p>
			<div className="row select-menu">
				<div className="col-6">
					<button className="w-100 rounded text-primary-dark" onClick={() => setIsRecipe(true)}>
						<i className="icon icon-plate xl-icon"></i>
						<span className="d-block">Select Recipe</span>
					</button>
				</div>
				<div className="col-6">
					<button className="w-100 rounded text-primary-dark" onClick={() => setIsFoodItem(true)}>
						<i className="icon icon-food xl-icon"></i>
						<span className="d-block">Add Food Item</span>
					</button>
				</div>
			</div>
		</div>
	);
};

const mapDispatchToProps = {};
export default connect(
	null,
	mapDispatchToProps
)(JournalCategory);
